class Payment < ApplicationRecord
  belongs_to :person
end
